import http from './http'

export default {
    create(solicitud) {
        return http.post('solicitudes/completa', solicitud)
            .then(response => response.data)
    }
}